<template>
  <div>
    <h1>Riders</h1>
    <v-btn color="primary" @click="createDialog = true" class="buttonStyle">
      Create Rider
    </v-btn>
    <v-data-table
      v-if="riders"
      :headers="headers"
      :items="riders"
      class="elevation-1 table datatable"
      :loading="loading"
      loading-text="Loading... Please wait"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-row>
          <span>
            <v-btn
              class="cnEditIcon"
              text
              icon
              color="blue lighten-2"
              @click="getRider(item.id)"
            >
              <v-icon>mdi-pencil-circle</v-icon>
            </v-btn>
          </span>
          <span>
            <v-btn
              class="cnEditIcon"
              text
              icon
              color="red lighten-2"
              @click="deleteRider(item.id)"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </span>
        </v-row>
      </template>
    </v-data-table>

    <!--DIALOG TO CREATE RIDER-->
    <v-dialog v-model="createDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Create Rider</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Name"
                  hint="Ali"
                  v-model="newRider.name"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Contact Number"
                  hint="03492039392"
                  v-model="newRider.number"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Email"
                  hint="Ali@gmail.com"
                  v-model="newRider.email"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Address"
                  hint="Saddar Karachi"
                  v-model="newRider.address"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="createDialog = false">
            Close
          </v-btn>
          <v-btn color="blue darken-1" text @click="createRider()">
            Create
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--DIALOG TO UPDATE RIDER-->
    <v-dialog v-if="rider" v-model="updateDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Update Rider</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Name"
                  hint="Ali"
                  v-model="rider.name"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Contact Number"
                  hint="03492039392"
                  v-model="rider.number"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Email"
                  hint="Ali@gmail.com"
                  v-model="rider.email"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Address"
                  hint="Saddar Karachi"
                  v-model="rider.address"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="updateDialog = false">
            Close
          </v-btn>
          <v-btn color="blue darken-1" text @click="updateRider()">
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--SNACKBAR FOR ERRORS-->
    <v-snackbar v-model="snackbar">
      {{ snackBarText }}

      <template>
        <v-btn color="secondary" text @click="snackbar = false"> Close </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

  <script>
import axios from "axios";
import { BASE_URL } from "./baseUrl";
/* eslint-disable */
export default {
  name: "RidersView",
  data() {
    return {
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "name",
        },
        { text: "Number", value: "number", sortable: false, filterable: false },
        { text: "Email", value: "email", sortable: false, filterable: false },
        {
          text: "Address",
          value: "address",
          sortable: false,
          filterable: false,
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          filterable: false,
        },
      ],
      options: {
        headers: {
          "Access-Control-Allow-Headers":
            "X-Custom-Header, Access-Control-Request-Headers",
          "x-access-token": localStorage.getItem("token"),
          //"Access-Control-Allow-Headers":"Access-Control-Allow-Origin"
        },
      },
      totalRiders: 0,
      riders: null,
      pageItems: 10,
      page: 1,
      loading: true,
      rider: null,
      syncing: false,
      searchTerm: null,
      snackbar: false,
      snackBarText: "",
      newRider: {
        name: "",
        email: "",
        address: "",
        number: "",
      },
      createDialog: false,
      updateDialog: false,
    };
  },
  mounted() {
    let options = {
      headers: {
        "Access-Control-Allow-Headers":
          "X-Custom-Header, Access-Control-Request-Headers",
        "x-access-token": localStorage.getItem("token"),
        //"Access-Control-Allow-Headers":"Access-Control-Allow-Origin"
      },
    };
    var url = BASE_URL + `riders/getAll`;
    axios
      .get(url, options)
      .then((response) => {
        console.log(response);
        this.riders = response.data.riders;
        this.totalRiders = response.data.totalCount;
        console.log(this.riders);
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
        this.errored = true;
      })
      .finally(() => (this.loading = false));
  },
  methods: {
    getAllRiders() {
      var url = BASE_URL + `riders/getAll`;
      axios
        .get(url, this.options)
        .then((response) => {
          console.log(response);
          this.riders = response.data.riders;
          this.totalRiders = response.data.totalCount;
          this.createDialog = false;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },

    getRider(id) {
      var url = BASE_URL + 'riders?id=' + id;
      axios
        .get(url, this.options)
        .then((response) => {
          console.log(response);
          this.rider = response.data;
          this.updateDialog = true;
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },

    createRider() {
      var url = BASE_URL + `riders/`;
      axios
        .post(url, this.newRider, this.options)
        .then((response) => {
          console.log(response);
          this.riders = response.data.riders;
          this.totalRiders = response.data.totalCount;
          this.getAllRiders();
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },

    deleteRider(id) {
      var url = BASE_URL + "riders?id=" + id;
      axios
        .delete(url, this.options)
        .then((response) => {
          console.log(response);
          if (response.data.hasError == false) {
            this.getAllRiders();
          } else {
            this.snackbar = true;
            this.snackBarText = response.data.message;
          }
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    updateRider() {
      var url = BASE_URL + 'riders/';
      axios
        .post(url, this.rider, this.options)
        .then((response) => {
          console.log(response);
          if (response.data.hasError == true) {
            this.snackbar = true;
            this.snackBarText = response.data.message;
            
          } else {
            this.getAllRiders();
          }
          this.updateDialog = false;
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped>
.buttonStyle {
  margin-top: -2%;
  float: right;
}

.datatable {
  margin-top: 3%;
}
</style>